import { getOperation, fetchOperation } from "utils/api";

export const queryList = async (params) => {
  return await getOperation("/transaction/list", {
    sort: "time,desc",
    ...params,
  });
};

export const queryTagList = async () => {
  return await getOperation("/tag/sys");
};

export const sendReceiptForm = async (params) => {
  return await fetchOperation("/transaction/action", {
    receiptType: "EMAIL",
    transactionType: "RECEIPT",
    ...params,
  });
};

export const exportCsv = async (params) => {
  return await getOperation("/transaction/list", {
    output: "csv",
    ...params,
  });
};
